import { render, staticRenderFns } from "./system-index.vue?vue&type=template&id=7d4e3880"
import script from "./system-index.vue?vue&type=script&lang=js"
export * from "./system-index.vue?vue&type=script&lang=js"
import style0 from "./system-index.vue?vue&type=style&index=0&id=7d4e3880&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports